__turbopack_context__.v({
  "card": "InfoCard-module-scss-module__ilq7ZW__card",
  "title": "InfoCard-module-scss-module__ilq7ZW__title",
  "value": "InfoCard-module-scss-module__ilq7ZW__value",
});
